import React, { ReactElement } from 'react';

import { Inject } from '@odinjs/odin';
import { AutocompleteAPI, FetchAPI, FieldAPI, FilterAPI, ModalService, Tooltip } from '@philips-internal/oswald-ui-components';
import Controller, { OnChange, OnDynamicContentRender, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ChangeEvent, RenderEvent } from '@philips-internal/oswald-ui-core/lib/component/types';

import { ReactComponent as DownloadSVG } from '../../../resources/assets/commons/download.svg';
import { FragmentNames, ProductManualAliases } from '../../codegen';
import { Application, ExternalManual } from '../../interfaces';
import { ManualService } from '../../services';
import { Utils } from '../../utils';
import BaseController from '../BaseController';

@Controller({ fragment: FragmentNames.PRODUCT_MANUAL })
export default class ProductManualController extends BaseController {

  @Inject(ProductManualAliases.AUTOCOMPLETE_APPLICATION)
  autocompleteApplication!: AutocompleteAPI;

  @Inject(ProductManualAliases.AUTOCOMPLETE_MODULE)
  autocompleteModule!: AutocompleteAPI;

  @Inject(ProductManualAliases.FIELD_MODULE)
  fieldModule!: FieldAPI;

  @Inject(ProductManualAliases.FILTER_LIST)
  filterList!: FilterAPI;

  @Inject(ProductManualAliases.FETCH_MODULE)
  fetchModule!: FetchAPI;

  @Inject(ProductManualAliases.FETCH_EXTERNAL)
  fetchExternal!: FetchAPI;

  @OnMount({ target: ProductManualAliases.LAYOUT_PRODUCT_MANUAL })
  onMount(): void {
    const event = new CustomEvent('updateModulesRoute', { detail: { moduleId: 'product-manual' } });
    dispatchEvent(event);
  }

  @OnMount({ target: ProductManualAliases.AUTOCOMPLETE_MODULE })
  onMountAutocompleteModule(): void {
    this.fetchModule.setParameters({ applicationId: undefined });
    this.autocompleteModule.setEnabled(false);
  }

  @OnChange({ target: ProductManualAliases.AUTOCOMPLETE_APPLICATION })
  onChangeAutocompleteApplication(event: ChangeEvent<Application>): void {
    this.autocompleteModule.setEnabled(Boolean(event.value));

    if (Boolean(event.value) && (event.value != event.oldValue)) {
      this.fetchModule.setParameters({ applicationId: event.value.id }, { skip: true });
    }
  }

  @OnDynamicContentRender(ProductManualAliases.DATA_TABLE_EXTERNAL)
  onRenderColumnsExternal(event: RenderEvent): void {
    switch (event.entry) {
      case 'name':
        event.render((data: ExternalManual): ReactElement => {
          return (<Tooltip value={data.name}>
            <div className="u-truncate">
              {data.name}
            </div>
          </Tooltip>);
        });
        break;
      case 'actions':
        event.render((data: ExternalManual): ReactElement => {
          return Utils.renderActionButtons([
            { title: 'product-manual.download', onClick: () => this.download(data), icon: DownloadSVG },
          ]);
        });
        break;
    }
  }

  download(data: ExternalManual): void {
    ModalService.openDialog({
      id: 'download-modal',
      fragment: 'download-modal',
      closeable: false,
    });
    ManualService.download(data.id, data.name)
      .catch(console.error)
      .finally(() => {
        ModalService.close('download-modal');
      });
  }

}
